import { useMemo } from 'react'
import { useAuth } from 'user-auth'
import { useMap } from '~map-preview/states/map'

function useIsMapOwner() {
  const map = useMap()
  const { userId } = useAuth()
  return useMemo(() => map?.creator?.id === userId, [map?.creator?.id, userId])
}

export { useIsMapOwner }
